import { useEffect, type FC, type PropsWithChildren } from 'react';

import { Locales } from 'constants/app';
import { PAY_METHOD, PaymentStatus } from 'constants/payment';
import { useTranslate } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAcquiring } from 'store/payment/slice';
import { HeaderSZ } from 'views/components/sz/ui';
import { Fade } from 'views/shared/fade';

const LayoutSZ: FC<PropsWithChildren> = ({ children }) => {
  const { paymentData, isPayment } = useAppSelector((state) => state.payment);
  const dispatch = useAppDispatch();
  const locale = localStorage.getItem('locale');
  const { changeLocale } = useTranslate();

  useEffect(() => {
    const bankAcquiring = paymentData?.acquirings.find((item) => {
      switch (item.formType) {
        case PAY_METHOD.BANK_CARD_1:
        case PAY_METHOD.BANK_CARD_3:
        case PAY_METHOD.BANK_CARD_9:
          return true;
        default:
          return false;
      }
    });

    if (bankAcquiring) {
      dispatch(setAcquiring(bankAcquiring));
    }
  }, [paymentData, dispatch]);

  useEffect(() => {
    if (locale !== Locales.ru) {
      changeLocale(Locales.ru);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-dvh flex-col items-center gap-6 bg-sz-gray-100 md:min-h-screen md:px-5 md:py-8">
      {paymentData?.status === PaymentStatus.WAIT_PAYMENT && (
        <HeaderSZ>
          <span className="leading-[26px] font-bold">
            {isPayment ? 'Пополнить баланс' : 'Выплата на банковскую карту'}
          </span>
        </HeaderSZ>
      )}
      <Fade className="w-full flex-grow flex">{children}</Fade>
    </div>
  );
};

export { LayoutSZ };
